import { LoaderFunction } from 'react-router-dom';
import { client } from '~/api/client';
import { queryData } from '~/api/data/request';
import { loadQuery } from '~/api/data/responses';
import {
  CaraWorkspaceFieldsFragment,
  GetCaraWorkspaceDocument,
  GetCaraWorkspaceQuery,
  GetCaraWorkspaceQueryVariables
} from '~/api/graphql';

export const getCaraWorkspace = async (id: string) =>
  queryData<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables, CaraWorkspaceFieldsFragment>(
    client,
    { query: GetCaraWorkspaceDocument, variables: { id: id } },
    (data) => data?.caraWorkspace
  );

export const loadCaraWorkspace: LoaderFunction = ({ params }) =>
  loadQuery(getCaraWorkspace(params.id || ''));
